const registrationInfoRequestUpdate = `
    mutation registrationInfoRequestUpdate($request:RegistrationInfoRequest)
    {
        registrationInfoRequestUpdate(request:$request) {
            id
            registrationInfo {
                data {
                    code
                    value
                }
            }
        }
    }
`;

export default registrationInfoRequestUpdate;
